import Module from './Module';
import manageFocus from '../services/manage-focus';

export default class ModulePopup extends Module {
	constructor(el) {
		super(el);

		const qs = {};
		location.search.replace(/([^?=&]+)(=([^&]*))?/g, function ($0, $1, $2, $3) {
			const qParam = $1.replace(/\-/g, ''); // Dashes needs to be removed since it can't be part of a Js variable name.
			qs[qParam.toLowerCase()] = unescape($3);
		});
		this.qs = qs;

		// -- Properties
		//--------------------------------------------------------------
		this.href = this.dom.el.attr('href') || this.dom.el.data('url');
		this.addedClass = this.dom.el.data('class')
			? this.dom.el.data('class')
			: '';
		this.autoplay = this.dom.el.data('autoplay');
		this.showName = this.dom.el.data('showname');
	}

	// -- Methods
	//--------------------------------------------------------------
	init() {
		this.create();
		this.bindEvents();
	}

	bindEvents() {
		const self = this;

		this.dom.el.on('click', (e) => {
			if (e) {
				e.preventDefault();
			}

			if (this.image) {
				if (!this.mobilePortrait) {
					$.featherlight({
						image: this.href,
						variant: self.variant,
					});
				}
			} else if (this.youtube) {
				$.featherlight(self.content, {
					type: self.type,
					afterContent() {},
					variant: self.variant,
				});

				self.play();
			} else {
				$.featherlight(self.content, {
					type: self.type,
					variant: self.variant,
					afterContent() {
						window.initClasses(this.$content);
					},
				});
			}
		});
	}

	get mobilePortrait() {
		let status = false;
		if (this.dom.w.width() < 480) {
			status = true;
		}
		return status;
	}

	create() {
		const { href } = this;
		this.content = null;

		this.html = $('<div />').html(this.dom.el.data('html')).html();
		if (href) {
			this.image = this.detectImage(href);
			this.youtube = this.detectYoutube(href);
		}

		if (this.html) {
			this.type = 'html';
			this.variant = 'html';
			this.content = `<div class="${
				this.addedClass
			}" role="dialog" aria-labelledby="modal-title" aria-modal="true">
                                <div id="modal-title" class="name">
                                    ${this.dom.el.data('name')}
                                </div>
                                <div class="content">
                                    ${this.html}
                                </div>
                            </div>`;
		} else if (this.image) {
			this.type = 'image';
			this.variant = 'image';
		} else if (this.youtube) {
			this.type = 'html';
			this.variant = 'youtube';
			this.player = null;
			this.key = this.youtubeKey();
			this.content = `<div class="video-wrapper">
                                <div id="youtube_player${this.key}"></div>
                            </div>`;
		}
		manageFocus();
	}

	detectImage(url) {
		return url.match(/\.(jpeg|jpg|gif|png)$/) !== null;
	}

	detectYoutube(url) {
		const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
		return url.match(p) ? RegExp.$1 : false;
	}

	youtubeKey() {
		const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		const match = this.href.match(regExp);

		if (match && match[2].length === 11) {
			return match[2];
		}
		console.log('Youtube URL incorrect');
	}

	play() {
		const self = this;
		const configYT = {
			videoId: self.key,
			playerVars: {
				rel: 0,
				showinfo: 0,
				modestbranding: 1,
				theme: 'light',
				enablejsapi: 1,
				showName: self.showName,
			},
			events: {
				onStateChange: self.onPlayerStateChange,
			},
		};

		if ($(this.dom.el).data('autoplay') === true) {
			configYT.events.onReady = self.onPlayerReady;
		}

		this.player = new YT.Player(`youtube_player${this.key}`, configYT);
		$(this.dom.el).data('autoplay', this.autoplay);

		this.player.showName = self.showName;
		this.player.startPlayback = false;
		this.player.playback50 = false;
		this.player.playback100 = false;
	}

	onPlayerReady(event) {
		event.target.playVideo();

		event.target.startPlayback = true;

		function publishGTM(event, eventCategory, eventAction, eventLabel) {
			const obj = {};

			obj.event = event;
			obj.eventCategory = eventCategory;
			obj.eventAction = eventAction;
			obj.eventLabel = eventLabel;

			window.dataLayer.push(obj);
		}
	}

	onPlayerStateChange(event) {
		if (event.data === 0) {
			// Video end
			closeModule();
		} else if (event.data == YT.PlayerState.PLAYING) {
			// Video Playing
			if (!event.target.startPlayback) {
				event.target.startPlayback = true;
			}
			videoLister(event); // Listen video
		}

		// Listen method to determin percentage of watched videos
		function videoLister(event) {
			const played = event.target.getCurrentTime();
			const videoLenght = event.target.getDuration();

			const percentage = Math.round((played * 100) / videoLenght);

			if (percentage >= 50 && !event.target.playback50) {
				event.target.playback50 = true;
			}

			if (percentage == 100 && !event.target.playback100) {
				event.target.playback100 = true;
				return;
			}

			setTimeout(videoLister, 500, event);
		}

		function closeModule() {
			// Actions to execute when the popup closes
			const current = $.featherlight.current();
			current.close();
		}

		// Send GTM infos regarding status of the video
		function publishGTM(event, eventCategory, eventAction, eventLabel) {
			const obj = {};

			obj.event = event;
			obj.eventCategory = eventCategory;
			obj.eventAction = eventAction;
			obj.eventLabel = eventLabel;

			window.dataLayer.push(obj);
		}
	}
}
